import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <section className="about-hero">
        <h1>About Jskerandco</h1>
        <p>We create jewelry that gives everyday moments a personal signature.</p>
        <div className="team-image">
          <img
            src="/site-assets/studio-team.png"
            alt="Jewelry artisans collaborating at a studio workbench"
          />
        </div>
      </section>

      <section className="our-mission">
        <h2>Our Point of View</h2>
        <h3>Details should feel personal.</h3>
        <p>
          Our collection brings together expressive shapes, thoughtful color,
          and options that let you choose a piece for your own story.
        </p>
        <p>
          We focus on clear product information and an uncomplicated online
          experience, so you can compare designs and select with confidence.
        </p>
      </section>

      <section className="our-story">
        <h2>How We Choose</h2>
        <h3>A considered collection, made for meaningful gifting.</h3>
        <p>
          We look for balanced proportions, wearable finishes, and details that
          make a piece feel distinctive. Each product page explains the options
          available for that design; availability may vary by item.
        </p>
        <div className="stats-grid">
          <div className="stat-item"><div className="stat-number">01</div><div className="stat-label">Choose a design</div></div>
          <div className="stat-item"><div className="stat-number">02</div><div className="stat-label">Select your options</div></div>
          <div className="stat-item"><div className="stat-number">03</div><div className="stat-label">Review before ordering</div></div>
        </div>
      </section>

      <section className="lowest-prices">
        <h2>Questions Before You Order?</h2>
        <h3>We are here to help.</h3>
        <p>
          For product, material, sizing, or order questions, email us at{" "}
          <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a>.
        </p>
      </section>
    </div>
  );
}

export default About;
